import { ReactNode } from 'react';
import './HeaderSection.scss';

type Props = {
  children: ReactNode;
};
export const HeaderSection: React.FC<Props> = ({ children }) => {
  return <header className="header-section">{children}</header>;
};
